import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import satellite from "./views/Satellite.vue";
import satelliteDetail from "./views/SatelliteDetail.vue";
import DataVendor from "./views/DataVendor.vue";
import Instrument from "./views/Instrument.vue";
import InstrumentDetail from "./views/InstrumentDetail.vue";
import Launch from "./views/Launch.vue";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            name: "home",
            component: Home,
            meta: { activeIndex: "/" },
        },
        {
            path: "/satellite",
            name: "satellite",
            component: satellite,
            meta: { activeIndex: "/satellite" },
        },
        {
            path: "/satellite/:id",
            name: "satellite-detail",
            component: satelliteDetail,
            meta: { activeIndex: "/satellite" },
            props: true,
        },
        {
            path: "/data-vendor",
            name: "data-vendor",
            component: DataVendor,
        },
        {
            path: "/instrument",
            name: "instrument",
            component: Instrument,
            meta: { activeIndex: "/instrument" },
        },
        {
            path: "/instrument/:id",
            name: "instrument-detail",
            component: InstrumentDetail,
            meta: { activeIndex: "/instrument" },
            props: true,
        },
        {
            path: "/launch",
            name: "launch",
            component: Launch,
            meta: { activeIndex: "/launch" },
        },
    ],
});
